module.exports = __webpack_public_path__ + "img/db.97b6e515.svg";